module.exports = __webpack_public_path__ + "media/images/default/homepage/about/train-bc15209707a1071cd6947dc4a6bc77b2.svg";